import { Link } from 'react-router-dom'

import styles from './BottomBar.module.scss'

const BottomBar = ({ handleNext, nextDisabled, buttonLabel }) => (
  <div className={styles.bottomBar}>
    <div className={styles.container}>
      <Link to="/hotels">
        <button className={styles.secondaryCta}>Cancel</button>
      </Link>
      <button className={styles.cta} disabled={nextDisabled} onClick={handleNext}>
        {buttonLabel}
      </button>
    </div>
  </div>
)

export default BottomBar
